// Simple event emitter for Vue 3 compatibility
// Provides the same API as Vue 2's event bus ($on, $emit, $off)
export class EventBus {
    constructor() {
        this.events = {};
    }

    $on(event, callback) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(callback);
    }

    $emit(event, ...args) {
        if (this.events[event]) {
            this.events[event].forEach(callback => callback(...args));
        }
    }

    $off(event, callback) {
        if (this.events[event]) {
            if (callback) {
                this.events[event] = this.events[event].filter(cb => cb !== callback);
            } else {
                delete this.events[event];
            }
        }
    }
}

// singleton instance for app-wide eventing
const bus = new EventBus();
export default bus;
